import { render } from "./signup-phone.vue?vue&type=template&id=4ec75526&scoped=true"
import script from "./signup-phone.vue?vue&type=script&lang=js"
export * from "./signup-phone.vue?vue&type=script&lang=js"

import "./signup-phone.vue?vue&type=style&index=0&id=4ec75526&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec75526"]])

export default __exports__